let config = {
   host_url: "https://deepvecto.com/api/",
  //host_url: "http://89.163.129.56:3450/",
  token: localStorage.getItem("token"),
  user_type: localStorage.getItem("usertype"),
  profile_img: localStorage.getItem("profile"),
  dollar_icon: "mdi mdi-currency-usd",
  rupee_icon: "mdi mdi-currency-inr",
  arrow_up_box_outline_icon: "mdi mdi-arrow-up-bold-box-outline",
  package_variant_icon: "mdi mdi-package-variant-closed",
  tag_outline_icon: "mdi mdi-tag-outline",
  export_icon: "mdi mdi-export",
  eye_off_outline: "mdi mdi-eye-off-outline",
  logo_with_text:
    "https://deepvecto.com/wp-content/uploads/2023/09/Deepvecto_Logo.png",
  logo_text: "https://deepvecto.com/api/logo_text.png",
  logo: "https://deepvecto.com/api/deepvectologo.png",
  v: 1.0,
};
module.exports = config;
